import {Link, useNavigate, useSearchParams} from "react-router-dom";

import sdk from "scoutli-sdk"

import logo from "../../assets/logo.png"
import {useEffect, useRef, useState} from "react";

const ChangePassword = () => {
    const password = useRef("")
    const passwordAgain = useRef("")

    const [type, setType] = useState(null)

    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate()

    useEffect(() => {
        sdk.passwordreset.checkToken(searchParams.get("token")).catch(() => {
            return navigate("/")
        })
    })

    return (
        <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <Link to="/">
                    <img
                        className="mx-auto h-12 w-auto"
                        src={logo}
                        alt="Scoutli"
                    />
                </Link>

                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Change password</h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 sm:rounded-lg sm:px-10">
                    <form className="space-y-6" action="#" method="POST" onSubmit={event => {
                        event.preventDefault()

                        sdk.passwordreset.changePassword(searchParams.get("token"), password.current.value, passwordAgain.current.value).then(() => {
                            setType(0)
                        }).catch(error => {
                            setType(error.en)
                        })
                    }}>
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                Password
                            </label>

                            <div className="mt-1">
                                <input
                                    ref={password}
                                    id="password"
                                    name="password"
                                    type="password"
                                    autoComplete="current-password"
                                    placeholder="********"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 transition-colors focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                Password Again
                            </label>

                            <div className="mt-1">
                                <input
                                    ref={passwordAgain}
                                    id="password-again"
                                    name="password-again"
                                    type="password"
                                    autoComplete="current-password"
                                    placeholder="********"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 transition-colors focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>

                        {type === 0 && (
                            <p className="mt-2 text-green-400 text-sm">Password successfuly changed.</p>
                        )}

                        {type !== null && type !== 0 && (
                            <p className="mt-2 text-red-400 text-sm">{type}</p>
                        )}

                        <div>
                            <button
                                type="submit"
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-white bg-brand transition-colors hover:bg-indigo-600"
                            >
                                Change password
                            </button>
                        </div>

                        <div className="text-sm text-center">
                            <Link to="/"
                                  className="font-medium text-indigo-600 transition-colors focus:outline-none hover:text-indigo-500">
                                Cancel and return
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ChangePassword;
